// extracted by mini-css-extract-plugin
export default {"loader":"ab372","load7":"P0joq"};